import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Login, OssSubmission, SalihaSubmission } from "../modules";
import Layout from "../modules/Layout";
import { AuthProvider } from "./AuthProvider";
import Home from "modules/Home/Home";
import PrivacyPolicy from "modules/PrivacyPolicy/PrivacyPolicy";
import OAuth from "modules/OAuth/pages/OAuth";
import SalihaSubmissionDetail from "modules/AuthSaliha/pages/SalihaSubmissionDetail";
import ForgotPassword from "modules/Auth/pages/ForgotPassword";
import VerifiedForgotPassword from "modules/Auth/pages/VerfiedForgotPassword";
import LnswSubmission from "modules/AuthLnsw/pages/LnswSubmission";
import Maintenance from "modules/Maintenance";
import LoginUser from "modules/Auth/pages/LoginUser";
// import Maintenance from "modules/Maintenance";


const Routers = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={
              <Home />
            }
            />
            <Route path="/pendamping" element={
              <Login />
              // <Maintenance />
            }
            />
            <Route path="/user/login" element={
              <LoginUser />
              // <Maintenance />
            }
            />
            <Route path="/oss" element={
              <OssSubmission />
            }
            />
            <Route path="/saliha" element={
              <SalihaSubmission />
              // <Maintenance />
            }
            />
             <Route path="/insw" element={
              <LnswSubmission />
              // <Maintenance />
            }
            />
            <Route path="/saliha/submission" element={
              // <Maintenance />
              <SalihaSubmissionDetail />
            }
            />
            <Route path="/oauth" element={
              <OAuth />
            }
            />
            <Route path="/privacy_policy" element={
              <PrivacyPolicy />
            }
            />
            <Route path="/forgot_password" element={
              <ForgotPassword />
            }
            />
            <Route path="/verified_forgot_password" element={
              <VerifiedForgotPassword />
            }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Routers;
